import script from "./OrderTableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderTableCell.vue?vue&type=script&lang=ts&setup=true"

import "./OrderTableCell.vue?vue&type=style&index=0&id=7592842c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7592842c"]])

export default __exports__